import SuggestedFiltersModal from './SuggestedFiltersModal';

export default SuggestedFiltersModal;
